<template>
  <div>
    <v-card>
      <v-card-title>
        <div class="headline">Clause Listing</div>
        <v-spacer></v-spacer>
        <v-text-field append-icon="mdi-magnify" label="Search" single-line hide-details v-model="search"></v-text-field>
      </v-card-title>
      <v-card-text>
        <v-data-table :headers="headers" :items="items" :search="search" :rows-per-page-items="itemsPerPage" :pagination.sync="pagination" item-key="name" :loading="loading" :no-data-text="noDataText" :filter="customSearch">
          <template slot="items" slot-scope="props">
            <td class="text-xs-left">{{ props.item.clseNo }}</td>
            <td class="text-xs-left">{{ props.item.clseTitle }}</td>
            <td class="text-xs-left">{{ props.item.clseTxt }}</td>
            <td class="text-xs-right">
              <table-action :rowData="props" :remove="checkAccess(['cargoRatingReview'])" @remove="doPromptRemove(props.item.clseNo)"></table-action>
            </td>
          </template>
        </v-data-table>
        <v-btn color="primary" dark class="mb-2" @click="doNewClse">
          Add Clause
          <v-icon right>mdi-plus</v-icon>
        </v-btn>
      </v-card-text>
      <v-dialog v-model="clseDialog" width="800px" lazy persistent>
        <v-card>
          <v-card-title>
            <span class="headline">Clause</span>
          </v-card-title>
          <v-card-text>
            <message :messages="messages"></message>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs6>
                  <v-autocomplete :items="clseList" v-model="clseForm.clseNo" :label="labels.clse" item-text="label" item-value="value" data-vv-name="clseNo" :data-vv-as="labels.clse" :error-messages="errors.collect('clseNo')" v-validate="'required'" @change="fetchClseTxt"></v-autocomplete>
                </v-flex>
              </v-layout>
              <v-layout>
                <v-flex xs12 v-if="clseForm.clseNo != null">
                  <v-subheader class="queryLabel">{{labels.clseTxt}}</v-subheader>
                  <div class="title">{{query.clseTxt}}</div>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="red darken-1" flat @click.native="doClose">Cancel</v-btn>
            <v-btn color="primary" flat @click.native="doSave">Save</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <confirm v-model="promptRemove" @ok="doDelete">
        Are you sure you want to delete the clause {{selectedId === null ? '' : selectedId.clseNo}}?
      </confirm>
    </v-card>
  </div>
</template>

<script>
import { listMixin } from '../../listMixin.js'
import * as TableConst from '@/mixins/table'
import { expandURI } from '@/utils/ajax'

export default {
  data() {
    return {
      headers: [
        { text: 'Clause No', value: 'clseNo' },
        { text: 'Clause Title', value: 'clseTitle' },
        { text: 'Clause Text', value: 'clseTxt' },
        TableConst.tableActionHeader
      ],
      labels: {
        clse: 'Clause',
        clseTxt: 'Clause Text'
      },
      clseForm: {
        busCls: this.id,
        clseNo: null
      },
      query: {
        clseTitle: null,
        clseTxt: null
      },
      clseList: [],
      clseDialog: false,
      newClse: false,
      selectedId: null,
      promptRemove: false
    }
  },
  mounted() {
    const apiURI = this.busClsMenu.clauseList
    this.$http.get(apiURI).then(result => {
      const { data } = result.data
      if (data) {
        this.clseList = data
      }
    })
    this.doFetch()
  },
  methods: {
    async doFetch() {
      this.loading = true
      const apiURI = this.busClsMenu.getClauses
      if (apiURI) {
        try {
          const expand = {
            busCls: this.id
          }
          const result = await this.$http.get(expandURI(apiURI, expand))
          const { data } = result.data
          this.items = []
          if (data) {
            data.map(clse => {
              const convertList = {
                clseNo: clse.clseNo,
                clseTitle: clse.clseTitle,
                clseTxt: clse.clseTxt
              }
              this.items.push(convertList)
            })
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
      this.loading = false
    },
    fetchClseTxt() {
      this.resetMessages()
      this.resetValidator()
      this.query.clseTitle = null
      this.query.clseTxt = null
      const apiURI = this.busClsMenu.clauseText
      if (apiURI) {
        const expand = {
          clseNo: this.clseForm.clseNo
        }
        this.$http.get(expandURI(apiURI, expand)).then(result => {
          const { data } = result.data
          this.query.clseTitle = data.clause.clseTitle
          this.query.clseTxt = data.clause.clseTxt
        })
      }
    },
    doNewClse() {
      this.newClse = true
      this.clseDialog = true
      this.doInitForm()
    },
    doSave() {
      this.resetMessages()
      this.$validator.validateAll().then(result => {
        if (result) {
          if (this.newClse) {
            this.doCreate()
          } else {
            // update??
          }
        } else {
          this.promptFieldCheck()
        }
      })
    },
    async doCreate() {
      const apiURI = this.busClsMenu.createClause
      if (apiURI) {
        try {
          const result = await this.$http.post(apiURI, this.clseForm)
          const data = result.data
          console.log(result)
          if (data) {
            this.notify(data)
            this.doFetch()
            this.doClose()
          }
        } catch (err) {
          try {
            const { data } = err.response
            if (data) {
              this.message(data)
              this.fieldMessage(data)
            }
          } catch (e) {
            console.log(err)
          }
        }
      }
    },
    doPromptRemove(clseNo) {
      this.doInitForm()
      this.selectedId = {
        busCls: this.id,
        clseNo
      }
      this.promptRemove = true
    },
    doDelete() {
      const apiURI = this.busClsMenu.deleteClause
      if (apiURI) {
        this.$http.post(apiURI, this.selectedId).then(result => {
          const data = result.data
          this.notify(data)
          this.doInitForm()
          this.doFetch()
        }).catch(err => {
          const { data } = err.response
          if (data) {
            this.message(data)
          }
        })
      }
    },
    doClose() {
      this.newClse = false
      this.clseDialog = false
      this.doInitForm()
    },
    doInitForm() {
      this.resetMessages()
      this.resetValidator()
      this.clseForm.clseNo = null
      this.query.clseTitle = null
      this.query.clseTxt = null
      this.selectedId = null
    }
  },
  computed: {
    busClsMenu() {
      return this.$store.state.parameters.busCls.busClsMenu.menu
    }
  },
  mixins: [
    listMixin
  ],
  props: ['id']
}
</script>

<style>
</style>
